import { SxProps, Theme } from "@mui/material";

export const modalContainerStyles: SxProps<Theme> = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  borderRadius: { xs: 1.5, sm: 2 },
  p: { xs: 1.5, sm: 2.5, md: 3 },
  zIndex: 10000,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: { xs: 1, sm: 1.5, md: 2 },
  minWidth: { xs: "calc(100% - 32px)", sm: 400 },
  maxWidth: { xs: "calc(100% - 32px)", sm: "90%", md: 500 },
  mx: { xs: 2, sm: 0 },
};

export const messageContainerStyles: SxProps<Theme> = {
  mb: { xs: 1, sm: 1.5, md: 2 },
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};

export const messageTextStyles = (
  index: number,
  arrayLength: number
): SxProps<Theme> => ({
  fontSize: { xs: "0.875rem", sm: "1rem", md: "1.25rem" },
  fontWeight: 600,
  mb: index < arrayLength - 1 ? { xs: 0.75, sm: 1 } : 0,
  textAlign: "center",
  px: { xs: 1, sm: 0 },
  lineHeight: { xs: 1.4, sm: 1.5 },
  width: "100%",
});

export const buttonsContainerStyles: SxProps<Theme> = {
  display: "flex",
  gap: { xs: 1, sm: 2 },
  mt: { xs: 1.5, sm: 2 },
  flexDirection: { xs: "column", sm: "row" },
  width: { xs: "100%", sm: "auto" },
};

export const continueButtonStyles: SxProps<Theme> = {
  minWidth: { xs: "100%", sm: 120 },
  fontSize: { xs: "0.875rem", sm: "1rem" },
  color: "#FFFFFF",
};

export const closeButtonStyles: SxProps<Theme> = {
  minWidth: { xs: "100%", sm: 120 },
  fontSize: { xs: "0.875rem", sm: "1rem" },
};

export const toastContainerStyles: SxProps<Theme> = {
  position: "fixed",
  top: { xs: 16, sm: 24 },
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "#1F2937",
  border: "1px solid rgba(239, 68, 68, 0.45)",
  borderRadius: "12px",
  px: { xs: 2, sm: 2.5 },
  py: { xs: 1.25, sm: 1.5 },
  zIndex: 10000,
  maxWidth: { xs: "calc(100% - 32px)", sm: 420 },
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
  pointerEvents: "none",
};

export const toastMessageTextStyles: SxProps<Theme> = {
  fontSize: { xs: "0.8125rem", sm: "0.875rem" },
  fontWeight: 600,
  color: "#FCA5A5",
  textAlign: "center",
  lineHeight: 1.45,
};
